module.exports = __webpack_public_path__ + "img/small_box.237c902e.png";